enum OnlinePaymentChannel {
    Mobile = 'Mobile',
    Web = 'Web',
}

export default OnlinePaymentChannel;
